/**
 * Portal API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 0.0.1
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { FilePatchBody } from '../model/filePatchBody';
import { FilePatchResponse } from '../model/filePatchResponse';
import { FilePostResponse } from '../model/filePostResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FilesService {

    protected basePath = 'https://sandbox-portal.hlcloud.com.au';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * This route get an image that was uploaded via the files route
     * @param id The unique image id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public filesImageIdGet(id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public filesImageIdGet(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public filesImageIdGet(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public filesImageIdGet(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling filesImageIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'image/_*',
            'text/html'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/files/image/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * This function allows you to update the following fields stored against a file: description, objectId, objectType. The objectType and objectId is used to store meta data against an image. So you can trace where the image is used. You will need the following data access:  upload_files or upload_public_files
     * @param body Patches the file details.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public filesPatch(body: FilePatchBody, observe?: 'body', reportProgress?: boolean): Observable<FilePatchResponse>;
    public filesPatch(body: FilePatchBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FilePatchResponse>>;
    public filesPatch(body: FilePatchBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FilePatchResponse>>;
    public filesPatch(body: FilePatchBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling filesPatch.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/html'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<FilePatchResponse>('patch',`${this.basePath}/files`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * This route allows you to upload a file to H&amp;L servers that can be access via http. You will need the following data access:  upload_files or upload_public_files
     * @param file 
     * @param locationId 
     * @param orgainsationId 
     * @param imageName 
     * @param description 
     * @param objectType 
     * @param objectId 
     * @param status 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public filesPostForm(file: Blob, locationId: string, orgainsationId: string, imageName: string, description: string, objectType: string, objectId: string, status: string, observe?: 'body', reportProgress?: boolean): Observable<FilePostResponse>;
    public filesPostForm(file: Blob, locationId: string, orgainsationId: string, imageName: string, description: string, objectType: string, objectId: string, status: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FilePostResponse>>;
    public filesPostForm(file: Blob, locationId: string, orgainsationId: string, imageName: string, description: string, objectType: string, objectId: string, status: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FilePostResponse>>;
    public filesPostForm(file: Blob, locationId: string, orgainsationId: string, imageName: string, description: string, objectType: string, objectId: string, status: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling filesPost.');
        }

        if (locationId === null || locationId === undefined) {
            throw new Error('Required parameter locationId was null or undefined when calling filesPost.');
        }

        if (orgainsationId === null || orgainsationId === undefined) {
            throw new Error('Required parameter orgainsationId was null or undefined when calling filesPost.');
        }

        if (imageName === null || imageName === undefined) {
            throw new Error('Required parameter imageName was null or undefined when calling filesPost.');
        }

        if (description === null || description === undefined) {
            throw new Error('Required parameter description was null or undefined when calling filesPost.');
        }

        if (objectType === null || objectType === undefined) {
            throw new Error('Required parameter objectType was null or undefined when calling filesPost.');
        }

        if (objectId === null || objectId === undefined) {
            throw new Error('Required parameter objectId was null or undefined when calling filesPost.');
        }

        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling filesPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/html'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }
        if (locationId !== undefined) {
            formParams = formParams.append('locationId', <any>locationId) as any || formParams;
        }
        if (orgainsationId !== undefined) {
            formParams = formParams.append('orgainsationId', <any>orgainsationId) as any || formParams;
        }
        if (imageName !== undefined) {
            formParams = formParams.append('imageName', <any>imageName) as any || formParams;
        }
        if (description !== undefined) {
            formParams = formParams.append('description', <any>description) as any || formParams;
        }
        if (objectType !== undefined) {
            formParams = formParams.append('objectType', <any>objectType) as any || formParams;
        }
        if (objectId !== undefined) {
            formParams = formParams.append('objectId', <any>objectId) as any || formParams;
        }
        if (status !== undefined) {
            formParams = formParams.append('status', <any>status) as any || formParams;
        }

        return this.httpClient.request<FilePostResponse>('post',`${this.basePath}/files`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
